import {useActions} from "../../../hooks/useActions";

import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {MusicService} from "../../../services/MusicService";

function ButtonPlay() {

    const {isLoading} = useTypedSelector(state => state.auth);
    const {
        setSystemMessage,
        updateUser,
        startLoadingGame
    } = useActions();

    return <div className="loginButtonPlay defaultButtonAnimation" onClick={async () => {
        if (isLoading) {
            return;
        }

        const jwtToken = localStorage.getItem('jwtToken');
        if (jwtToken) {
            try {
                await updateUser();
                await startLoadingGame();
                MusicService.playMenuMusic();

                return;
            } catch (e) {
                setSystemMessage({
                    isVisible: true,
                    type: 'info',
                    text: String(e),
                    action: null
                });
            }
        }

    }}>
    </div>

}

export default ButtonPlay;